import logo from './logo.svg';
import "./index.css";
import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import PricingPage from "./pages/PricingPage";
import SignupPage from './pages/SignupPage';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import DashboardPage from './pages/DashboardPage';
import SavingsPlanPage from './pages/SavingsPlanPage';
import TransactionsPage from './pages/TransactionsPage';
import InvestmentsPage from './pages/InvestmentsPage';
import ProtectedRoute from './components/protectedRoute';
import NotificationsPage from './pages/NotificationPage';
import PaymentsPage from './pages/PaymentsPage';
import ActivatePage from './pages/ActivatePage';
import AboutUs from './pages/AboutUsPage';
import ProfilePage from './pages/ProfilePage';

function App() {
  return (
    <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/signUp" element={<SignupPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgotPassword" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/activate" element={<ActivatePage />} />
          
          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/saving-plans" element={<SavingsPlanPage />} />
            <Route path="/transactions" element={<TransactionsPage />} />
            <Route path="/investments" element={<InvestmentsPage />} />
            <Route path="/notifications" element={<NotificationsPage />} />
            <Route path="/payments" element={<PaymentsPage />} />
            <Route path="/profile" element={<ProfilePage />} />
          </Route>
        </Routes>
    </Router>
  );
}

export default App;
